<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-01-02 11:11:55
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-12-13 14:25:50
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <h3 style="text-align:center">{{ order_name }}</h3>
        <a-divider orientation="center">{{ $t('returnExchange.baseInfo') }}</a-divider>
        <Form class="returnFactory" :form="returnFactoryForm1"></Form>

        <a-divider orientation="center">{{ $t('returnExchange.returnInfo') }}</a-divider>
        <Form 
            class="returnFactory" 
            :form="returnFactoryForm2" 
            @handleInputChange="handleInputChangeForm2" 
            @handleSelectChange="handleSelectChangeForm2"
            @handleSelectDate="handleSelectDate"
        ></Form>
        <Upload
            class="uploadImg"
            @changeUpload="changeUpload"
            @errorUpload="errorUpload"
        >
            <template #desc>
                <div class="uploadDesc">{{ $t('returnExchange.uploadDesc') }}</div>
            </template>
        </Upload>

        <a-divider orientation="center">{{ $t('returnExchange.returnFactoryInfo') }}</a-divider>
        <Form 
            class="returnFactory" 
            :form="returnFactoryForm3"  
            @handleInputChange="handleInputChangeForm3" 
            @handleSelectChange="handleSelectChangeForm3"
            @handleSelectDate="handleSelectDate"
        ></Form>

        <a-divider orientation="center">{{ $t('returnExchange.orderLineInfo') }}</a-divider>
        <!-- 调整弹窗宽度 -->
        <a-radio-group v-model="activeKey" type="button">
            <a-radio value="large" @click="handleWidth('large')">{{ $t('base.large')}}</a-radio>
            <a-radio value="medium" @click="handleWidth('medium')">{{ $t('base.medium')}}</a-radio>
            <a-radio value="small" @click="handleWidth('small')">{{ $t('base.small')}}</a-radio>
        </a-radio-group>
            
        <Table
            class="deliverTable"
            ref="tableRef"
            :table="table"
            @selectRow="selectRow"
            @selectAllRow="selectRowAll"
            @changePage="changeVersionPage"
            @changePageSize="changeVersionPageSize"
        >
                <template v-slot:columns="{ props }"> 
                    <div v-if="props.column.key == 'back_quantity'">
                        <a-inputNumber 
                            v-model="props.record.back_quantity" 
                            :disabled="props.record.disabled" 
                            :style="{width:'80px'}" 
                            :min="0"
                            :max="9999"
                            :precision="0"
                            :hideButton="true"
                            :error="props.record.error"
                            @input="(val)=>quantityChange(val,props.record)"
                            @change="(val)=>quantityChange(val,props.record)"
                        />
                    </div>
                    <div v-if="props.column.key == 'swap_quantity'">
                        <a-inputNumber 
                            v-model="props.record.swap_quantity" 
                            :style="{width:'80px'}" 
                            allow-clear
                            :min="1"
                            :max="9999"
                            :precision="0"
                            :hideButton="true"
                        />
                    </div>
                    <div v-if="props.column.key == 'swap_inventory_code'">
                        <a-select 
                            v-model="props.record.swap_inventory_code" 
                            :style="{width:'250px'}" 
                            allow-search 
                            :disabled="props.record.swapInventoryCodeDisabled"
                            @change="(val)=>changeInventoryCode(val,props.record)"
                        >
                            <a-option v-for="(item,index) in swapInventoryCodeOptions" :key="index">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'swap_inventory'">
                        <a-select 
                            v-model="props.record.swap_inventory" 
                            :style="{width:'250px'}" 
                            @change="(val)=>changeInventory(val,props.record)"
                        >
                            <a-option v-for="(item,index) in swapInventoryOptions" :key="index">
                                {{ item.label }}
                            </a-option>
                        </a-select>
                    </div>
                    <div v-if="props.column.key == 'instruction'">
                        <a-input 
                        :style="{width:'250px'}"
                        v-model="props.record.instruction" 
                        :placeholder="t('base.enterSomething')" 
                        allow-clear />
                    </div>
                </template>
        </Table>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import Upload from '@/components/Upload.vue';
    import { ReturnFactoryForm1, ReturnFactoryForm2, ReturnFactoryForm3 } from './queryConfig/ReturnFactoryForm.js';
    import { dateToTimestamp, timestampToDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()
    const emits = defineEmits(['handleReturnWidth'])
    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        visible:{
            type:Boolean,
            default:false,
        }
    })

    console.log(props.row,'propsssssss')

    const returnFactoryForm1 = reactive(ReturnFactoryForm1)
    const returnFactoryForm2 = reactive(ReturnFactoryForm2)
    const returnFactoryForm3 = reactive(ReturnFactoryForm3)
    const order_name = ref('')
    const rowData = ref(null)
    const activeKey = ref('medium')
    const tableRef = ref(null)
    const selected = ref([])
    const swapInventoryOptions = ref([])
    const swapInventoryCodeOptions = ref([])
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '出库单号',
                title:t('order.deliveryNumber'),
                dataIndex: 'delivery_number',
                key: 'delivery_number',
                width: '220',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: '产品名称',
                title:t('order.productName'),
                dataIndex: 'product_name',
                key: 'product_name',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: 'SKU',
                title:t('order.sku'),
                dataIndex: 'sku',
                key: 'sku',
                width: '150',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
                slotName:'sku',
            },
            {
                // title: '物料编码',
                title:t('order.inventoryCode'),
                dataIndex: 'inventory_code',
                key: 'inventory_code',
                width: '160',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: 'ERP行号',
                title:t('order.erpLineNo'),
                dataIndex: 'erp_line_no',
                key: 'erp_line_no',
                width: '130',
                align: 'center',
                ellipsis:true,
                tooltip:true,
                show:true,
            },
            {
                // title: '发货日期',
                title:t('returnExchange.deliveryDate'),
                dataIndex: 'delivery_date',
                key: 'delivery_date',
                width: '190',
                align: 'center',
                show:false,
            },
            {
                // title: '返修中数量',
                title:t('returnExchange.returningFactoryQty'),
                dataIndex: 'returning_factory_qty',
                key: 'returning_factory_qty',
                width: '190',
                align: 'center',
                show:false,
            },
            {
                // title: '退货数量',
                title:t('returnExchange.backQuantity'),
                dataIndex: 'back_quantity',
                key: 'back_quantity',
                width: '120',
                align: 'center',
                show:true,
                slotName:'slot',
            },
            {
                // title: '返修数量',
                title:t('returnExchange.returnFactoryQty'),
                dataIndex: 'swap_quantity',
                key: 'swap_quantity',
                width: '170',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '整车物料编码',
                title:t('order.sku'),
                dataIndex: 'swap_inventory_code',
                key: 'swap_inventory_code',
                width: '270',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '换货仓库',
                title:t('returnExchange.warehouse'),
                dataIndex: 'swap_inventory',
                key: 'swap_inventory',
                width: '270',
                align: 'center',
                show:false,
                slotName:'slot',
            },
            {
                // title: '备注',
                title:t('order.instruction'),
                dataIndex: 'instruction',
                key: 'instruction',
                width: '270',
                align: 'center',
                show:true,
                slotName:'slot',
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 480
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            rowSelection:{
                type: 'checkbox',
                showCheckedAll: true,
                onlyCurrent: false,
            },
            selected:[],
            expandable:'',
            expand:false,
            pagination:false,
            
        },
    })


    const init = ()=>{
        returnFactoryForm1.formField.forEach(i=>{
            if(i.key !== 'source'){
                returnFactoryForm1.formData[i.key] = ''
            }
        })
        returnFactoryForm2.formField.forEach(i=>{
            returnFactoryForm2.formData[i.key] = ''
        })
        returnFactoryForm3.formField.forEach(i=>{
            returnFactoryForm3.formData[i.key] = ''
            if(i.key == 'swap_courier_no'){
                i.disabled = true
                i.required = false
            }
        })

        returnFactoryForm1.formData.type = 4
        returnFactoryForm1.formData.status = 1
        returnFactoryForm1.formData.source = rowData.value.source
        returnFactoryForm1.formData.source_val = rowData.value.source_val
        returnFactoryForm1.formData.order_id = rowData.value.id
        returnFactoryForm1.formData.erp_no = rowData.value.erp_no == '-'? '' : rowData.value.erp_no
        returnFactoryForm1.formData.customer_entity_id = rowData.value.customer_entity_id
        returnFactoryForm1.formData.customer_id = rowData.value.customer_id
        returnFactoryForm1.formData.customer_name = rowData.value.customer_name
        returnFactoryForm1.formData.customer_erp_code = rowData.value.customer_erp_code
        returnFactoryForm2.formData.file = ''

        let courier_no_item = returnFactoryForm2.formField.find(i=> i.key == 'courier_no')
        let courier_type = returnFactoryForm2.formField.find(i=> i.key == 'courier_type')
        courier_no_item.required = true
        courier_type.required = true
        // courier_type.disabled = true
        courier_no_item.disabled = true

        // 重置表格
        tableRef.value.selectedKeys = []
        tableRef.value.selectedData = []
    }

    const handleInputChangeForm2 = (item,val)=>{

        if(item.key == 'courier_no' && !!val){
            getCourierId()
        }else if(!val){
            returnFactoryForm2.formData.back_courier_id = ''
        }
    }

    const handleInputChangeForm3 = (item,val)=>{
        console.log(item,val,'val,opt,item',!!val)
        if(item.key == 'swap_courier_no' && !!val){
            getSwapCourierId()
        }else if(!val){
            returnFactoryForm3.formData.swap_courier_id = ''
        }
    }

    const handleSelectChangeForm2 = (val,opt,key)=>{
        // console.log(val,opt,key,'val,opt,key')
        if(key == 'courier_type'){
            let courierNoItem = returnFactoryForm2.formField.find(i=> i.key == 'courier_no')
            if(!!val && returnFactoryForm2.formData.courier_no === ''){
                courierNoItem.disabled = false
            }else if(!!val && returnFactoryForm2.formData.courier_no !== ''){
                getCourierId()
            }else{
                returnFactoryForm2.formData.courier_no = ''
                returnFactoryForm2.formData.back_courier_id = ''
                courierNoItem.disabled = true
            }
        }
    }

    const handleSelectChangeForm3 = (val,opt,key)=>{
        // console.log(val,opt,key,'val,opt,key222222')
        if(key == 'swap_courier_type'){
            let courierNoItem = returnFactoryForm3.formField.find(i=> i.key == 'swap_courier_no')
            courierNoItem.required = !!returnFactoryForm3.formData.swap_courier_type
            if(!!val && returnFactoryForm3.formData.swap_courier_no === ''){
                courierNoItem.disabled = false
            }else if(!!val && returnFactoryForm3.formData.swap_courier_no !== ''){
                getSwapCourierId()
            }else{
                returnFactoryForm3.formData.swap_courier_no = ''
                returnFactoryForm3.formData.swap_courier_id = ''
                courierNoItem.disabled = true
            }
        }
    }

    const handleSelectDate = (val,date,item)=>{
        // console.log(val,date,item,'val,date,item', props.row)

        // if(item.key == 'back_timestamp'){
        //     let order_timestamp = dateToTimestamp(props.row.order_timestamp)
        //     let back_timestamp = dateToTimestamp(val.split(' ')[0])
        //     if(back_timestamp < order_timestamp){
        //         Modal.warning({
        //             title: t('base.tip'),
        //             titleAlign:'start',
        //             content: t('order.returnDateTip'),
        //             hideCancel:true,
        //             okText:t('base.ok'),
        //             cancelText:t('base.cancel'),
        //             onOk:()=>{
        //                 createOrderForm1.formData.back_timestamp = ''
        //             }
        //         });
        //     }
        // }

        // if(item.key == 'swap_timestamp_plan'){
        //     let order_timestamp = dateToTimestamp(props.row.order_timestamp)
        //     let back_timestamp = dateToTimestamp(val.split(' ')[0])
        //     if(back_timestamp < order_timestamp){
        //         Modal.warning({
        //             title: t('base.tip'),
        //             titleAlign:'start',
        //             content: t('order.planDateTip'),
        //             hideCancel:true,
        //             okText:t('base.ok'),
        //             cancelText:t('base.cancel'),
        //             onOk:()=>{
        //                 createOrderForm1.formData.swap_timestamp_plan = ''
        //             }
        //         });
        //     }
        // }
        
    }

    const selectRow = (val)=>{
        // console.log(val,'vb')
        selected.value = val
    }

    const selectRowAll = (val)=>{
        selected.value = val
    }

    const quantityChange = (val,row)=>{
        console.log(val,row,'99999')
        row.swap_quantity = val
    }

    const changeInventoryCode = (val,row)=>{
        console.log(val,row,'mmmmmmmm111')
        let item = swapInventoryCodeOptions.value.find(i=> i.label == val)
        row.swap_inventory_code_val = item.value
    }

    const changeInventory = (val,row)=>{
        console.log(val,row,'mmmmmmmm22222')
        let optItem = swapInventoryOptions.value.find(i=> i.label == val)
        row.swap_inventory_val = optItem.value
    }

    const handleWidth = (type)=>{
        activeKey.value = type
        emits('handleReturnFactoryWidth',type)
    }

    // 上传中
    const changeUpload = (fileList)=>{
        let arr = []
        if(fileList.length > 0){
            fileList.forEach(i=>{
                if(i.status == 'done'){
                    arr.push(i.response.data)
                }
            })
        }
        returnFactoryForm2.formData.file = arr.join(',')
    }

    // 上传失败
    const errorUpload = (fileItem)=>{
        // console.log(fileItem,'失败')
        Message.error(t('returnExchange.uploadFail'))
    }
    
    // 获取订单行
    const getOrderLine = async (id,row)=>{
        let param = {
            order_id: id,
        }
        table.value.configs.loading = true
        let res = await OrderApi.getInstance().getStockOutList(param)
        if(res.code == 0){
            res.data.forEach(i=>{
                i.stock_out_id = i.id
                i.erp_line_no = i.erp_line_no == undefined? '-' : i.erp_line_no
                i.product_name = i.product_map == undefined? '-' : i.product_map.english_name
                i.inventory_code = i.inventory_code == undefined? '-' : i.inventory_code 
                i.quantity = i.quantity == undefined? '-' : i.quantity
                i.ship_quantity = i.ship_qty == undefined? '-' :i.ship_qty
                i.back_number = i.back_number == undefined? '-' : i.back_number
                i.returning_factory_qty = i.back_map == undefined? 0 : i.back_map['4'] == undefined? 0 : i.back_map['4']['1']
                i.swap_inventory_code = ''
                i.swap_inventory = ''
                i.swap_quantity = ''
                i.disabled = i.ship_qty == i.back_number // 是否允许勾选
                i.product_code = i.category_code
                i.delivery_date = timestampToDate(i.delivery_date * 1000).split(' ')[0]
            })

            console.log(res.data,'res.data')

            // 未取消出库的订单行
            table.value.datas = []
            res.data.forEach(i=>{
                if(i.status == 2){
                    table.value.datas.push(i)
                }
            })
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取原因类型
    const getReasonType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "back_reason"})
        if(res.code == 0){
            let item = returnFactoryForm2.formField.find(i=> i.key == 'back_reason_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取IBS验证方案类型
    const getIBSVerificationType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "order",dict_sub_code: "IBS_verification_type"})
        if(res.code == 0){
            let item = returnFactoryForm2.formField.find(i=> i.key == 'ibs_verification_type')
            item.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label:i.dict_sub_name,
                    value:i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取物流公司
    const getCourierType = async ()=>{
        let res = await OrderApi.getInstance().getCourierType({dict_code: "courier_back"})
        if(res.code == 0){
            let item = returnFactoryForm2.formField.find(i=> i.key == 'courier_type')
            let item2 = returnFactoryForm3.formField.find(i=> i.key == 'swap_courier_type')
            item.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                item.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
                item2.options.push({
                    label: i.dict_sub_name,
                    value: i.dict_sub_value,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取退货物流id
    const getCourierId = async ()=>{
        let param = {
            courier_type: returnFactoryForm2.formData.courier_type,
            courier_no: returnFactoryForm2.formData.courier_no,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            returnFactoryForm2.formData.back_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取换货物流id
    const getSwapCourierId = async ()=>{
        let param = {
            courier_type: returnFactoryForm3.formData.swap_courier_type,
            courier_no: returnFactoryForm3.formData.swap_courier_no,
        }
        let res = await OrderApi.getInstance().getCourierId(param)
        if(res.code == 0){
            returnFactoryForm3.formData.swap_courier_id = res.data.id
        }else{
            Message.error(res.msg)
        }
    }

    // 获取仓库
    const getWarehouse = async ()=>{
        let res = await OrderApi.getInstance().getWarehouse()
        if(res.code == 0){
            swapInventoryOptions.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                swapInventoryOptions.value.push({
                    label: `${i.description} (${i.subinventory_name})`,
                    value: i.subinventory_name,
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到换货物料编码下拉数据
    const getProductList = async ()=>{
        let res = await OrderApi.getInstance().getProductList({})
        if(res.code == 0){
            swapInventoryCodeOptions.value = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.category_code !== undefined && i.category_code == '627.501'){
                    let model = i.model == undefined? 'null' : i.model
                    let modelYear = i.model_year == undefined? 'null' : i.model_year
                    let brandName = i.brand_name == undefined? 'null' : i.brand_name
                    let partName = i.part_name == undefined? 'null' : i.part_name
                    swapInventoryCodeOptions.value.push({
                        label: i.english_name == undefined? i.sku : `${i.sku} | ${i.english_name} | ${model} | ${modelYear} | ${brandName} | ${partName}`,
                        value: i.inventory_code
                    })
                }
            })
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>props.row,(nVal,oVal)=>{
        rowData.value = nVal
    })
    watch(()=>props.visible,async (nVal,oVal)=>{
        rowData.value = props.row
        order_name.value = props.row.order_name
        getReasonType()
        getIBSVerificationType()
        getCourierType()
        getProductList()
        getWarehouse()
        await getOrderLine(rowData.value.id, rowData.value)
        init()
    })

    defineExpose({
        rowData,
        returnFactoryForm1,
        returnFactoryForm2,
        returnFactoryForm3,
        selected
    })
</script>

<style lang="less" scoped>
.returnFactory{
    min-width: 70%;
    max-width:75%;
    margin:0 auto;
    padding:20px;

    /deep/ .arco-form{
        display: block;
        text-align: center;
    }

    /deep/ .arco-input-wrapper .arco-input{
        height: 30px;
        width:100%;
    }

    /deep/ .arco-select,
    /deep/ .arco-textarea,
    /deep/ .arco-picker{
        height: 40px;
    }
}

/deep/ .arco-table-th{
    background-color: #333 !important;
    color: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    padding: 0;
    font-weight: 300;
    font-size:12px;
}

.uploadImg{
    /deep/ .arco-form-item-content-flex{
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-top: 8px;
        margin-left: 20px;
    }
}
.uploadDesc{
    margin-bottom: 3px;
    font-size: 12px;
    color: #4d83ff;
} 
</style>